import React, { useEffect } from 'react'
import { useQueryClient } from 'react-query'
import { useAuth } from '@/contexts/AuthContext'
import { useAuthedSocket } from '@/hooks/useAuthedSocket'
import type { Alert, AlertsBootstrap } from '@/types/alerts'
import { ALERTS_KEY, applyNewAlert, useAlerts } from './useAlerts'

export const AlertsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const qc = useQueryClient()
  const { token } = useAuth()

  // Dispara a carga inicial do bootstrap uma vez no ponto persistente (não depende
  // do AlertBell estar montado). Mesma query key → cache compartilhado com o sino.
  useAlerts()

  useAuthedSocket('/alerts', {
    events: {
      'alert.new': (alert: Alert) => {
        qc.setQueryData<AlertsBootstrap>(ALERTS_KEY, (prev) =>
          applyNewAlert(prev ?? { items: [], unreadCount: 0 }, alert),
        )
      },
      // Aviso de empresa mudou de estado: a lista e o contador vêm do servidor
      // (o "volta como não lido" é calculado lá, por usuário).
      'alert.updated': () => {
        qc.invalidateQueries(ALERTS_KEY)
      },
    },
    reconnectQueryKeys: [ALERTS_KEY],
  })

  // Logout: limpa o cache para não vazar alertas entre contas.
  useEffect(() => {
    if (!token) qc.removeQueries(['alerts'])
  }, [token, qc])

  return <>{children}</>
}
